// 能力图谱
import request from '@/utils/request'

// 获取框架列表
export function getCapabilityFrame(data) {
  return request({
    url: '/capability/frame/list',
    method: 'POST',
    data,
  })
}
// 获取框架全部数据
export function getCapabilityFrameAll(data) {
  return request({
    url: '/capability/frame/all',
    method: 'POST',
    data,
  })
}
// 新增框架
export function addCapabilityFrame(data) {
  return request({
    url: '/capability/frame/save',
    method: 'POST',
    data,
  })
}
// 编辑框架
export function editCapabilityFrame(data) {
  return request({
    url: `capability/frame/save/${data.id}`,
    method: 'POST',
    data,
  })
}
// 删除框架
export function deleteCapabilityFrame(data) {
  return request({
    url: `capability/frame/delete`,
    method: 'POST',
    data,
  })
}

// 更新框架共享状态
export function updateCapabilityFrameStatus(data) {
  return request({
    url: '/capability/frame/status',
    method: 'POST',
    data,
  })
}
// 查看框架详情
export function getCapabilityFrameDetail(id) {
  return request({
    url: `capability/frame/${id}`,
    method: 'POST',
  })
}
// 获取评价指标
export function getCapabilityConfiguration(data) {
  return request({
    url: '/capability/configuration/level',
    method: 'POST',
    data,
  })
}
// 获取课程能力达成
export function getCourseCapability(data) {
  return request({
    url: 'capability/stat/course',
    method: 'POST',
    data,
  })
}
// 课程全部学生达成情况筛选条件
export function getCourseCapabilitySearchParam(data) {
  return request({
    url: '/capability/stat/search-param',
    method: 'POST',
    data,
  })
}
// 课程全部学生达成情况分页查询
export function getCourseCapabilityStatPagination(data) {
  return request({
    url: '/capability/stat/pagination',
    method: 'POST',
    responseType: data.print === 1 ? 'blob' : '',
    data,
  })
}
// 获取单个学生能力达成
export function getCourseCapabilityStatStudent(data) {
  return request({
    url: '/capability/stat/student',
    method: 'POST',
    data,
  })
}

// 图谱概况
export function getCapabilityMap(data) {
  return request({
    url: `capability/stat/map`,
    method: 'POST',
    data,
  })
}
// 获取课程能力图谱配置1信息
export function getCapabilityStep1(data) {
  return request({
    url: `capability/configuration/step1`,
    method: 'POST',
    data,
  })
}
// 获取课程能力图谱配置1信息
export function getCapabilityStep2(data) {
  return request({
    url: `capability/configuration/step2`,
    method: 'POST',
    data,
  })
}
// 提交图谱配置1
export function submitCapabilityStep1(data) {
  return request({
    url: `capability/configuration/submit-step1`,
    method: 'POST',
    data,
  })
}
// 提交图谱配置2
export function submitCapabilityStep2(data) {
  return request({
    url: `capability/configuration/submit-step2`,
    method: 'POST',
    data,
  })
}
// 获取课程能力图谱配置3信息
export function getCapabilityStep3(data) {
  return request({
    url: `capability/configuration/step3`,
    method: 'POST',
    data,
  })
}
// 提交图谱配置3
export function submitCapabilityStep3(data) {
  return request({
    url: `capability/configuration/submit-step3`,
    method: 'POST',
    data,
  })
}
// 获取关联主题
export function getCapabilityConfigurationSection(data) {
  return request({
    url: `capability/configuration/section`,
    method: 'POST',
    data,
  })
}
// 获取关联活动
export function getCapabilityConfigurationActivity(data) {
  return request({
    url: `capability/configuration/activity`,
    method: 'POST',
    data,
  })
}

// 获取能力图谱总体概况
export function getCapabilityTotal() {
  return request({
    url: `capability/total`,
    method: 'POST',
  })
}
// 获取图谱配置信息
export function getCapabilityGraphConfig() {
  return request({
    url: `capability/config`,
    method: 'POST',
  })
}
// 获取课程图谱列表
export function getCapabilityCourseGraphList(data) {
  return request({
    url: `capability/map-list`,
    method: 'POST',
    data
  })
}
// 获取专业列表
export function getCapabilityMajorAll() {
  return request({
    url: `capability/major-all`,
    method: 'POST',
  })
}
// 获取年级列表
export function getCapabilityGradeAll() {
  return request({
    url: `capability/grade-all`,
    method: 'POST',
  })
}
// 获取自定义主题
export function getCapabilitySectionList(data) {
  return request({
    url: `capability/section/list`,
    method: 'POST',
    data
  })
}
// 保存自定义主题
export function saveCapabilitySection(data) {
  return request({
    url: `capability/section/save`,
    method: 'POST',
    data
  })
}
// 删除自定义主题
export function deleteCapabilitySection(data) {
  return request({
    url: `capability/section/delete`,
    method: 'POST',
    data
  })
}
// 获取课程详细信息
export function getCapabilityCourseDetail(data) {
  return request({
    url: 'capability/stat/course-detail',
    method: 'POST',
    data,
  })
}
// 查看课程指定学生信息
export function getCapabilityCourseStatStudent(data) {
  return request({
    url: 'capability/stat/target',
    method: 'POST',
    data,
  })
}
// 获取学生课程AI学习建议
export function getCapabilityAiSuggestion(data) {
  return request({
    url: 'capability/stat/ai-suggestion',
    method: 'POST',
    data,
  })
}
// 获取未配置图谱课程列表
export function getCapabilityNoMapGraph() {
  return request({
    url: 'capability/no-map',
    method: 'POST',
  })
}
// 获取能力图谱配置权限,传courseId
export function getCapabilityUpdatePriv(data) {
  return request({
    url: 'capability/configuration/get-course-update-priv',
    method: 'POST',
    data,
  })
}